module.exports = __webpack_public_path__ + "static/media/ic-languages-spoken.0712e2e3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/ic-languages-spoken.svg
// module id = 781
// module chunks = 0